"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Main = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
      paddingTop: theme.functions.toRem(theme.variables.mainVerticalPadding),
      paddingBottom: theme.functions.toRem(theme.variables.mainVerticalPadding),
      paddingLeft: theme.functions.toRem(theme.variables.mainHorizontalPadding),
      paddingRight: theme.functions.toRem(theme.variables.mainHorizontalPadding)
    }, theme.breakpoints.gt.mobile.portrait, {
      paddingLeft: theme.functions.toRem(theme.variables.mainHorizontalPaddingMobilePortrait),
      paddingRight: theme.functions.toRem(theme.variables.mainHorizontalPaddingMobilePortrait)
    }), theme.breakpoints.gt.tablet.portrait, {
      paddingLeft: theme.functions.toRem(theme.variables.mainHorizontalPaddingTabletPortrait),
      paddingRight: theme.functions.toRem(theme.variables.mainHorizontalPaddingTabletPortrait)
    }), theme.breakpoints.gt.tablet.landscape, {
      paddingLeft: theme.functions.toRem(theme.variables.mainHorizontalPaddingTabletLandscape),
      paddingRight: theme.functions.toRem(theme.variables.mainHorizontalPaddingTabletLandscape)
    }), "marginLeft", 'auto'), "marginRight", 'auto'), "maxWidth", theme.functions.toRem(theme.variables.mainMaxWidth)), "textAlign", 'left')
  };
});
/*:: type Props = {
  className?: string,
  children?: React.Node
};*/
var Main = exports.Main = React.forwardRef(function (_ref /*:: */, ref) {
  var className = _ref /*:: */.className,
    children = _ref /*:: */.children;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("section", {
    className: (0, _classnames.default)(classes.root, className),
    ref: ref
  }, children);
});
Main.displayName = 'Main';
var _default = exports.default = Main;
//# sourceMappingURL=Main.js.map